export default __webpack_public_path__ + "static/media/detail_mobile_14_6.c2515291.jpg";